"use strict";
'kiwi public';
/** @module */

/**
 * Command input Alias + re-writing
 *
 * Variables used in aliases:
 * - $0 = the command being run
 * - $1 = first param of input
 * - $N = Nth param of input
 * - $1+2 = first param of input and the next 2 words
 * - $2+4 = second param of input and the next 4 words
 * - $2+ = second param of input and all words after
 * - $variable = variable as set in the vars object
 */

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-int"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));

var AliasRewriter = /*#__PURE__*/function () {
  function AliasRewriter() {
    (0, _classCallCheck2.default)(this, AliasRewriter);
    // Max alias recursion depth
    this.recursiveDepth = 3; // Current alias recursion depth

    this.depth = 0;
    this.aliases = {};
  }
  /** Reset the current aliases object from a newline delimited string of aliases */


  (0, _createClass2.default)(AliasRewriter, [{
    key: "importFromString",
    value: function importFromString(str) {
      var _context,
          _this = this;

      // Clear out the current aliases before adding new ones in
      this.aliases = {};
      (0, _forEach.default)(_context = str.split('\n')).call(_context, function (line) {
        var _context2;

        if (line[0] !== '/') {
          return;
        }

        var spaceSep = (0, _indexOf.default)(line).call(line, ' ');

        if (spaceSep === -1) {
          return;
        }

        var command = line.substring(0, spaceSep);
        var actions = (0, _trim.default)(_context2 = line.substring(spaceSep + 1)).call(_context2);

        if (!actions) {
          return;
        }

        _this.aliases[command.toLowerCase()] = actions;
      });
    } // Takes an array of words to process!

  }, {
    key: "processInput",
    value: function processInput(input, vars) {
      var words = input || [];
      var alias = this.aliases[words[0].toLowerCase()];
      var aliasLen;
      var currentAliasWord = '';
      var currentAliasWordLen = 0;
      var processedConditionals = false;
      var compiled = []; // If an alias wasn't found, return the original input

      if (!alias) return input; // Split the alias up into useable words

      alias = alias.split(' ');
      aliasLen = alias.length; // Iterate over each word and pop them into the final compiled array.
      // Any $ words are processed with the result ending into the compiled array.

      for (var i = 0; i < aliasLen; i++) {
        currentAliasWord = alias[i];
        currentAliasWordLen = currentAliasWord.length; // $var? word makes this command only run if the var exists

        if (!processedConditionals && currentAliasWord[0] === '$' && currentAliasWord[currentAliasWordLen - 1] === '?') {
          var checkVar = currentAliasWord.substr(1, currentAliasWordLen - 2);

          if (!vars[checkVar]) {
            compiled = [];
            break;
          } else {
            continue;
          }
        } else {
          processedConditionals = true;
        } // Non $ word


        if (currentAliasWord[0] !== '$') {
          compiled.push(currentAliasWord);
          continue;
        } // Refering to an input word ($N)


        if ((currentAliasWord[1] || '').match(/\d/)) {
          var num = currentAliasWord.match(/\$(\d+)(\+)?(\d+)?/); // Did we find anything or does the word it refers to non-existant?

          if (!num || !words[num[1]]) continue;

          if (num[2] === '+' && num[3]) {
            // Add X number of words
            compiled = (0, _concat.default)(compiled).call(compiled, (0, _slice.default)(words).call(words, (0, _parseInt2.default)(num[1], 10), (0, _parseInt2.default)(num[1], 10) + (0, _parseInt2.default)(num[3], 10)));
          } else if (num[2] === '+') {
            // Add the remaining of the words
            compiled = (0, _concat.default)(compiled).call(compiled, (0, _slice.default)(words).call(words, (0, _parseInt2.default)(num[1], 10)));
          } else {
            // Add a single word
            compiled.push(words[(0, _parseInt2.default)(num[1], 10)]);
          }

          continue;
        } // Refering to a variable


        if (typeof vars[currentAliasWord.substr(1)] !== 'undefined') {
          // Get the variable
          compiled.push(vars[currentAliasWord.substr(1)]);
          continue;
        }
      }

      return compiled;
    }
    /** Take a string input, process any aliases and output the finalised string */

  }, {
    key: "process",
    value: function process(input, vars) {
      var line = input || '';
      var words = line.split(' ');
      var firstWord = (words[0] || '').toLowerCase();
      this.depth++;

      if (this.depth >= this.recursiveDepth) {
        this.depth--;
        return line;
      }

      if (this.aliases[firstWord]) {
        words = this.processInput(words, vars);
        firstWord = (words[0] || '').toLowerCase();

        if (this.aliases[firstWord]) {
          words = this.process(words.join(' '), vars).split(' ');
        }
      }

      this.depth--;
      return words.join(' ');
    }
  }]);
  return AliasRewriter;
}();

exports.default = AliasRewriter;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["AliasRewriter"]
window._kiwi_exports.libs.AliasRewriter = exports.default ? exports.default : exports;
